import { rectInfo } from '~/components/gfr/utils/types'

export const prefixClass = (c: string, prefix = 'gfr') => {
  return `${prefix}-${c}`
}
export const prefixAnime = (c: string, prefix = 'gfr') => {
  return `${prefix}-anime-${c}`
}

export function getBoundingClientRect(elem: HTMLElement): rectInfo {
  const elemRect = elem?.getBoundingClientRect()
  if (!elemRect) return { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 }
  return {
    width: Math.ceil(elemRect?.width),
    height: Math.ceil(elemRect?.height),
    top: Math.ceil(elemRect?.top),
    bottom: Math.ceil(window.innerHeight - elemRect?.bottom),
    left: Math.ceil(elemRect?.left),
    right: Math.ceil(elemRect?.right)
  }
}
